export async function runNotificationRequestWithRetry<T>(options: {
  fetcher: (signal: AbortSignal) => Promise<T>;
  attempts?: number;
  timeoutMs?: number;
  onAttempt?: (controller: AbortController) => void;
  shouldContinue?: () => boolean;
}): Promise<T> {
  const attempts = Math.max(1, options.attempts ?? 2);
  const timeoutMs = Math.max(1, options.timeoutMs ?? 12_000);
  const shouldContinue = options.shouldContinue ?? (() => true);
  let lastError: unknown;

  for (let attempt = 0; attempt < attempts; attempt += 1) {
    if (!shouldContinue()) {
      throw lastError ?? new Error('Notification request cancelled');
    }

    const controller = new AbortController();
    options.onAttempt?.(controller);
    const timeout = setTimeout(() => controller.abort(), timeoutMs);

    try {
      return await options.fetcher(controller.signal);
    } catch (error) {
      lastError = error;
      if (!shouldContinue() || attempt === attempts - 1) throw error;
    } finally {
      clearTimeout(timeout);
    }
  }

  throw lastError ?? new Error('Failed to load notifications');
}
